<template>
  <footer class="py-4">
    <SocialLinks v-if="enableSocial"/>
    <!-- Please consider donating on the link below or keeping this on your page 🤘 -->
  </footer>
</template>
<script>
import SocialLinks from './SocialLinks'

export default {
  components: {
    SocialLinks
  },
  data () {
    return {
      enableSocial: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue